export default "https://assets.egbcdn.net/assets/packs/_/images/app/manual/manual5-db4773dadae62b083257d3bdcd632ebe.png";